import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '40%',
    maxWidth: 500,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  deleteButton: {
    marginLeft: 8
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 36
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 16
  },
  space: {
    marginBottom: 8
  },
  inputWithLable: {
    marginTop: 8
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
